// Arquivo gerado por scripts/gerar-versao.js. Não editar.
export const versao = {
  "versao": "1.0.4",
  "commit": "85ed2894",
  "dataBuild": "2026-11-03T13:07:15.979Z"
};
